export const DEFAULT_RETAINED_ROUTE = '/spatial-vision';

export function resolveRetainedRoute(path, search = '', isLoggedIn = false) {
  // The old singular alias and shared project URLs remain valid entry points.
  if (path === '/project') return '/projects';
  if (path === '/' || path === '' || (path === '/login' && isLoggedIn)) {
    const params = new URLSearchParams(search);
    return params.get('projectId') || params.get('pId')
      ? '/projects'
      : DEFAULT_RETAINED_ROUTE;
  }
  return path;
}
